module.exports = __webpack_public_path__ + "img/IMG_6689_L_BlackMatted.01acdc05.jpg";